/*
 * Copyright (c) 2023 CalAmp Corp. All Rights Reserved
 */
import React from 'react';
import {dlsColor} from '../theme/theme';
import {useThemeMode} from '../theme/useThemeContext';
import ThemeIconProvider from './ThemeIconProvider';

export type SideNavVisionIconProps = {
  color?: string;
}
/*
 * Defines the Design Language System (DLS) Side Nav Vision Icon component.
 */
export const SideNavVisionIcon = ({color = dlsColor('white')}: SideNavVisionIconProps) => {
  // re-renders on a theme mode change so the default color re-resolves ...
  useThemeMode();
  return (
    <ThemeIconProvider name='SideNavVisionIcon' color={color as any} legacyIcon={(
      <svg width="26" height="16" viewBox="0 0 26 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M10.914 7.98853L9.5 9.17005V6.81676L10.914 7.98853Z" stroke={color} strokeWidth="3" />
        <path d="M24.5 14V2H23L18.5 6.5V8V9.5L23 14H24.5Z" stroke={color} strokeWidth="1.5" />
        <path d="M1.5 13C1.5 14.1046 2.39543 15 3.5 15H16.5C17.6046 15 18.5 14.1046 18.5 13V3C18.5 1.89543 17.6046 1 16.5 1H3.5C2.39543 1 1.5 1.89543 1.5 3V13Z" stroke={color} strokeWidth="1.5" />
      </svg>
    )} />
  );
};

export default SideNavVisionIcon;
